import { createSlice } from '@reduxjs/toolkit'

// Creating a user slice
const userSlice = createSlice({
  name: 'users',
  initialState: {
    usersList: [],
    loggedIn: false,
    ipCountry: null
  },
  reducers: {
    addUser: (state, action) => {
      state.loggedIn = action.payload
    },
    setIpCountry: (state, action) => {
      state.ipCountry = action.payload
    }
  }
})

//// * * * Creating a user actions * * *
export const { addUser, setIpCountry } = userSlice.actions

export default userSlice.reducer


